module.exports = __webpack_public_path__ + "resources/img/certi_csa_star.9d3e59207e2a22703746c1a1b9467b58.png";